import { useCapitalGlobalProposalStep1Form } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.context';
import { PrivacyPolicyModal } from '@/shared/components/privacy-policy-modal/privacy-policy-modal.component';
import { useState, type MouseEvent } from 'react';

export function CapitalGlobalProposalPrivacyConsentSection() {
  const { form, isViewMode, shouldShowStep1FieldErrors } =
    useCapitalGlobalProposalStep1Form();
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);

  const openPrivacyPolicy = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setIsPrivacyPolicyOpen(true);
  };

  return (
    <>
      <form.AppField
        name='privacyAccepted'
        validators={{
          onChange: ({ value, fieldApi }) => {
            if (isViewMode) return undefined;
            if (!shouldShowStep1FieldErrors(fieldApi)) return undefined;
            if (!value) return 'É necessário aceitar a política de privacidade';
            return undefined;
          },
        }}
        children={field => (
          <field.CheckboxField
            label={
              <>
                Confirmo que o titular dos dados foi informado sobre a{' '}
                <button
                  type='button'
                  onClick={openPrivacyPolicy}
                  className='text-alba-green-600 underline'
                >
                  Política de privacidade
                </button>
                .
              </>
            }
            required
            disabled={isViewMode}
          />
        )}
      />

      <PrivacyPolicyModal
        isOpen={isPrivacyPolicyOpen}
        onClose={() => setIsPrivacyPolicyOpen(false)}
      />
    </>
  );
}
